module.exports = __webpack_public_path__ + "static/media/eyes.d4f6b764.png";